import download from 'downloadjs';

export const csvHeaderValues = ['lastName', 'firstName', 'email', 'username', 'password'];

export function downloadCSVTemplate() {
  download(
    csvHeaderValues.join(','),
    'Albert Template for Creating Student Accounts.csv',
    'text/csv'
  );
}
